export interface IStationScheme {
  idScheme: number;
  PictureData: string;
}

const isStationSchemeRecord = (value: unknown): value is IStationScheme =>
  value !== null && typeof value === "object" && "idScheme" in value && (value as IStationScheme).idScheme != null;

export const normalizeStationSchemeResponse = (json: unknown): IStationScheme[] | null => {
  if (Array.isArray(json)) {
    const schemes = json.filter(isStationSchemeRecord);
    return schemes.length ? schemes : null;
  }

  if (isStationSchemeRecord(json)) {
    return [json];
  }

  if (json && typeof json === "object") {
    const schemes = Object.values(json).filter(isStationSchemeRecord);
    return schemes.length ? schemes : null;
  }

  return null;
};

export enum ObjectClassParam {
  CAlarmStatusObject = "CAlarmStatusObject",
  CSchemeButtonObject = "CSchemeButtonObject",
  CAnalogDisplayObject = "CAnalogDisplayObject",
  CThermometerObject = "CThermometerObject",
  CAngularGaugeObject = "CAngularGaugeObject",
  CLinearGaugeObject = "CLinearGaugeObject",
  C7SegmentObject = "C7SegmentObject",
  CLedRoundObject = "CLedRoundObject",
  CLedRoundExtObject = "CLedRoundExtObject",
}

export interface IStationSchemeObject {
  jumpType: number;
  jumpTarget: number;
  ObjectClass: ObjectClassParam;
  SchemeBindObjectType: number;
  SchemeIdBindObject: number;
  idleStatus?: boolean;
  left: number;
  top: number;
  right: number;
  bottom: number;
  TopLevelName?: string;
  TrainName?: string;
  TrainType?: number;
  TrainColour?: number;
  ctrlSettings?: string | null;
  ctrlProps?: Record<string, unknown> | null;
  ctrlComponentName?: string | null;
  value?: string | null;
  rawValue?: number | null;
  valueUnits?: number | null;
  ldd: string | null;
  alarmStatus?: number;
  unacknowledgedEvent: number;
  useIcon: number;
}
